// Next Diamonds - PDP Expandable (v4)
//
// Smooth open/close on every toggle, using Element.animate() so onfinish
// is guaranteed to fire (the previous transitionend approach got stuck on
// the 2nd click). Targets:
//   details.nd-spec-tab    (Ring Details, Ring Description)
//   details.nd-trust-card  (Free shipping, returns, warranty, etc.)
//   details.nd-engraving   (Engraving input)
// Sticky column is now disabled, so we do not need to lock the scroll any
// more. The page does not jump.

console.log('[ND expandable v4] script loaded');

(function () {
  'use strict';

  var DUR_OPEN  = 280;
  var DUR_CLOSE = 220;
  var EASING    = 'cubic-bezier(0.4, 0, 0.2, 1)';

  var SELECTOR = [
    'details.nd-spec-tab',
    'details.nd-trust-card',
    'details.nd-engraving',
    '.product-info details[data-nd-smooth]'
  ].join(',');

  function getBody(details) {
    var summary = details.querySelector('summary');
    if (!summary) return null;
    var node = summary.nextElementSibling;
    while (node && node.tagName === 'STYLE') node = node.nextElementSibling;
    return node;
  }

  function bind(details) {
    if (details.dataset.ndSmooth === '1') return;
    details.dataset.ndSmooth = '1';

    var summary = details.querySelector('summary');
    var body = getBody(details);
    if (!summary || !body) return;

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      // Cancel any animation in progress on this details
      if (details._ndAnim) {
        try { details._ndAnim.cancel(); } catch (_) {}
        details._ndAnim = null;
      }

      if (details.open) {
        // ----- closing -----
        var startH = body.scrollHeight;
        body.style.overflow = 'hidden';
        body.style.height = startH + 'px';
        details._ndAnim = body.animate(
          [{ height: startH + 'px' }, { height: '0px' }],
          { duration: DUR_CLOSE, easing: EASING }
        );
        details._ndAnim.onfinish = function () {
          details.open = false;
          body.style.overflow = '';
          body.style.height = '';
          details._ndAnim = null;
        };
        details._ndAnim.oncancel = function () {
          body.style.overflow = '';
          body.style.height = '';
          details._ndAnim = null;
        };
      } else {
        // ----- opening -----
        details.open = true;
        var endH = body.scrollHeight;
        body.style.overflow = 'hidden';
        body.style.height = '0px';
        details._ndAnim = body.animate(
          [{ height: '0px' }, { height: endH + 'px' }],
          { duration: DUR_OPEN, easing: EASING }
        );
        details._ndAnim.onfinish = function () {
          body.style.overflow = '';
          body.style.height = '';
          details._ndAnim = null;
        };
        details._ndAnim.oncancel = function () {
          body.style.overflow = '';
          body.style.height = '';
          details._ndAnim = null;
        };
      }
    });
  }

  function bindAll() {
    document.querySelectorAll(SELECTOR).forEach(bind);
  }

  function init() {
    bindAll();
    var mo = new MutationObserver(bindAll);
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
